import { createFileRoute } from '@tanstack/react-router'
import IsaChatPage from '@/pages/isa-chat/isa-chat-page'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/chat/$chatId',
)({
  component: function IsaChatConversationRoute() {
    const { dashboardId, chatId } = Route.useParams()
    return <IsaChatPage dashboardId={dashboardId} chatId={chatId} />
  },
})
